var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "247px",
    viewBox: "0 0 214 247",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.44424438%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-blob-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17EAD9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6078EA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paid-courses",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.336997768
  }, /*#__PURE__*/React.createElement("g", {
    id: "payment-final-stage,-input-details",
    transform: "translate(-311.000000, -631.000000)",
    fill: "url(#linearGradient-blob-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-+-Path-6-+-Path-8-Mask",
    transform: "translate(261.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.9949851,539.076649 C107.886147,540.578668 121.95637,532.313042 131.205652,514.279772 C145.079576,487.229866 144.36089,475.722565 182.464783,469.050655 C220.568675,462.378745 243.471691,473.178948 255.189558,484.337542 C266.907425,495.496137 273.29036,557.974581 230.116926,577.025557 C201.334636,589.726208 194.533275,612.031128 209.712843,643.940318 C221.05585,684.778966 209.9615,707.852331 176.429795,713.160413 C126.132236,721.122535 68.8214245,671.730255 71.7484698,641.111924 C73.6998334,620.699703 66.4503434,599.337581 50,577.025557 C50.0769339,560.527862 52.4086261,550.047306 56.9950766,545.583892 C61.581527,541.120477 72.2481632,538.951396 88.9949851,539.076649 Z",
    id: "Path-6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob1);
export default __webpack_public_path__ + "static/media/blob_1.ed55f08992af5164be4b3fd5d191f431.svg";
export { ForwardRef as ReactComponent };